import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33d1498c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=33d1498c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d1498c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/drone/src/components/Header/index.vue').default})
